import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';

export function ConfirmDialog({
    open,
    title,
    message,
    confirmLabel,
    color = 'primary',
    busy = false,
    onCancel,
    onConfirm,
}: {
    open: boolean;
    title: string;
    message: string;
    confirmLabel: string;
    color?: 'primary' | 'error';
    busy?: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}) {
    const { t } = useTranslation();
    return (
        <Dialog open={open} onClose={busy ? undefined : onCancel} maxWidth="xs" fullWidth>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText>{message}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} disabled={busy}>
                    {t('common.cancel')}
                </Button>
                <Button onClick={onConfirm} color={color} variant="contained" disabled={busy} autoFocus>
                    {confirmLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
